<template>
  <v-container fluid>
    <v-layout class="hide-on-print" row wrap>
      <v-flex xs12>
        <v-card>
          <v-tabs
              fixed-tabs
              background-color="primary"
              dark
              height="40"
              v-model="tab">
            <v-tab href="#detail">
              <v-icon class="mr-2" size="15">mdi-account-card-details</v-icon>
              Trekking Detail
            </v-tab>
            <v-tab href="#history">
              <v-icon class="mr-2" size="15">mdi-history</v-icon>
              Trekking History
            </v-tab>
            <v-tabs-items v-model="tab">
              <v-tab-item value="detail">
                <v-flex class="d-flex justify-space-between mb-3 ml-3 mt-3  align-center" xs12>
                  <h3 class="font-weight-bold">Trekking Request
                    <v-chip class="text-white font-weight-thin"
                            :color="statusColor">
                      {{ latest_status }}
                    </v-chip>
                  </h3>
                </v-flex>

                <v-flex>
                  <v-alert outlined type="info" v-if="trekkingData.assignment">
                    <div class="d-flex align-end"
                         v-if="trekkingData.assignment.assignee_id === user.id">
                      <div class="mr-2">Please proceed for
                        {{ trekkingData.assignment.purpose_name }}.
                      </div>
                      <div v-if="trekkingData.assignment.remarks">
                        ({{ trekkingData.assignment.remarks }})
                      </div>
                    </div>
                    <div v-else>
                      This application has been forwarded to
                      {{ trekkingData.assignment.assignee_name }} for
                      {{ trekkingData.assignment.purpose_name }}
                    </div>
                  </v-alert>
                </v-flex>


                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <confirmation-header-text class="ml-2" icon="mdi-alpha-t-box"
                                                  text="Trekking Route"/>
                      </v-flex>
                      <v-flex sm3 xs12>
                        <list-item-detail :sub_title="trekkingData.trekkingRoute.name" title="Trekking Route">
                        </list-item-detail>
                      </v-flex>
                      <v-flex sm3 v-if="trekkingData.no_of_days" xs12>
                        <list-item-detail :sub_title="trekkingData.no_of_days" title="Number Of Days">
                        </list-item-detail>
                      </v-flex>
                      <v-flex sm3 v-if="trekkingData.starting_date" xs12>
                        <list-item-detail :sub_title="trekkingData.starting_date" title="Starting Date">
                        </list-item-detail>
                      </v-flex>
                      <v-flex sm3 v-if="trekkingData.end_date" xs12>
                        <list-item-detail :sub_title="trekkingData.end_date" title="End Date">
                        </list-item-detail>
                      </v-flex>

                      <v-flex xs12>
                        <v-divider class="my-3"/>
                      </v-flex>

                      <confirmation-header-text class="ml-2" icon="mdi-account"
                                                text="Trekker's Info:"/>
                      <v-flex class="pt-0" xs12>
                        <v-simple-table class="mx-4" light>
                          <thead>
                          <tr>
                            <th class="text-left">Name</th>
                            <th class="text-left">Country</th>
                            <th class="text-left">Document number</th>
                            <th class="text-left">Document type</th>
                            <th class="text-left">Validity</th>
                            <th class="text-left">Dcoument</th>
                            <th class="text-left">Recommendation Letter</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="trekker in trekkingData.trekkers">
                            <td>
                              {{ trekker.name }}
                            </td>
                            <td>{{ trekker.country }}</td>
                            <td>{{ trekker.passport_number }}</td>
                            <td>{{ trekker.document_type }}</td>
                            <td>{{ trekker.validity }}</td>
                            <td>
                              <file-display :avatar="true" :key="trekker.document"
                                            :src="trekker.document"/>
                            </td>
                            <td>
                              <file-display :avatar="true" :key="trekker.recommendation_letter"
                                            :src="trekker.recommendation_letter"/>
                            </td>
                          </tr>
                          </tbody>
                        </v-simple-table>
                      </v-flex>

                      <v-flex xs12>
                        <v-divider class="my-3"/>
                      </v-flex>

                      <payment-detail :payment_detail="trekkingData.payment_detail" :paid="trekkingData.paid"
                                      v-if="trekkingData.paid"/>
                      <v-flex v-else xs12>
                        <confirmation-header-text class="ml-2" icon="mdi-alpha-p-box"
                                                  text="Payment Info:"/>
                        <v-flex v-if="trekkingData.total_cost" xs3>
                          <list-item-detail :sub_title="trekkingData.total_cost"
                                            title="Charge For Trekking Permit(USD)">
                          </list-item-detail>
                        </v-flex>
                        <v-flex v-if="trekkingData.voucher_number" xs3>
                          <list-item-detail :sub_title="trekkingData.voucher_number"
                                            title="Voucher Number">
                          </list-item-detail>
                        </v-flex>
                      </v-flex>

                      <!--                        <v-flex xs12 v-if="trekkingData.recommendation">-->
                      <!--                            <confirmation-header-text class="ml-2" icon="mdi-alpha-E-box"-->
                      <!--                                                      text="Recommendation Letter:"/>-->
                      <!--                            <v-flex xs6>-->
                      <!--                                <file-list-item-detail :avatar="true"-->
                      <!--                                                       :src="trekkingData.recommendation"-->
                      <!--                                                       sub_title="Recommendation File"/>-->
                      <!--                            </v-flex>-->
                      <!--                        </v-flex>-->

                      <v-flex xs12>
                        <v-dialog
                            class="hide-on-print"
                            persistent
                            v-model="tippaniDialog"
                            width="800">

                          <v-card class="hide-on-print">
                            <v-toolbar color="blue darken-3" dark v-if="step===1">
                              <v-toolbar-title>Generate tippani</v-toolbar-title>
                            </v-toolbar>
                            <v-card-text class="pa-0">
                              <v-container grid-list-md>
                                <v-layout wrap>
                                  <v-flex :class="{'hide':step ===2}" xs12>
                                    <v-form class="pa-2" lazy-validation ref="formRef">
                                      <v-layout row wrap>
                                        <v-flex class="py-0" xs12>
                                          <v-select
                                              :items="tippanis"
                                              @change="fillTippani"
                                              item-text="name"
                                              item-value="id"
                                              label="Tippani type"
                                              outlined
                                              v-model="selectedTippani"/>
                                        </v-flex>
                                        <v-flex class="py-0" xs12>
                                          <div>
                                            <div id="editor"></div>
                                          </div>
                                        </v-flex>
                                      </v-layout>
                                    </v-form>
                                  </v-flex>
                                  <v-flex :class="{'hide':step ===1}">
                                    <single-trekking-request-tippani-print-content/>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card-text>
                            <v-divider style="margin-top:31px;"/>
                            <v-card-actions>
                              <v-spacer/>
                              <v-btn @click="cancel" class="white--text" color="red lighten-1">
                                Cancel
                              </v-btn>
                              <v-btn
                                  @click="proceed"
                                  class="white--text"
                                  color="blue darken-3 "
                                  v-if="step===1">
                                Proceed
                              </v-btn>
                              <v-btn
                                  @click="print('tippani')"
                                  class="white--text"
                                  color="blue darken-3"
                                  v-if="step === 2"
                              >Print
                              </v-btn>
                              <v-btn
                                  @click="save"
                                  class="white--text"
                                  color="blue darken-3"
                                  v-if="step === 2 && (trekkingData.voucher_number || trekkingData.total_cost == 0)"
                              >Save
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
                <v-footer class="sticky" color="blue darken-1" fixed height="auto">
                  <v-layout row wrap v-if="!trekkingData.is_verified">
                    <v-spacer/>
                    <v-btn @click="verifyTrekking" :loading="loading" class="text-white" color="blue mr-2"
                           v-if="trekkingData.can_verify">
                      Verify
                    </v-btn>
                    <v-btn
                        @click="rejectModal=true "
                        class="text-white ml-2"
                        color="red lighten-1"
                        v-if=" trekkingData.can_verify">
                      Reject
                    </v-btn>
                  </v-layout>
                  <v-layout row wrap v-else>
                    <v-spacer/>
                    <v-btn v-if="showForward" @click="forwardToUser(1)"
                           class="text-white" color="blue mr-2">
                      Forward
                    </v-btn>
                    <v-btn @click="verifyTippaniGenerated" class="text-white" color="blue mr-2"
                           v-if="showTippaniVerification">
                      Verify Tippani
                    </v-btn>
                    <v-btn @click="approveTippaniGenerated" class="text-white" color="blue mr-2"
                           v-if="showTippaniApprove">
                      Approve Tippani
                    </v-btn>
                    <v-btn @click="generateTippani"
                           v-if="(trekkingData.voucher_generated || trekkingData.total_cost == 0) && !trekkingData.tippani_generated"
                           class="text-white"
                           color="blue mr-2"
                    >
                      Generate tippani
                    </v-btn>
                    <v-btn @click="print('tippani')" v-if="trekkingData.tippani_generated" class="text-white"
                           color="blue mr-2">
                      Print tippani
                    </v-btn>
                    <v-btn @click="exemptionDialog = true" class="text-white mr-2" color="blue"
                           v-if="(!trekkingData.voucher_number || trekkingData.total_cost !== 0) && !trekkingData.paid">
                      Exempt cost
                    </v-btn>
                    <v-btn @click="print('voucher')" class="text-white ml-2" color="blue"
                           v-if="trekkingData.voucher_generated && trekkingData.status === 'Applied' && !trekkingData.paid">
                      Print Voucher
                    </v-btn>
                    <v-btn @click="checkPayment" class="text-white" color="blue mr-2" :loading="loading"
                           v-if="trekkingData.voucher_generated && !trekkingData.paid ">
                      Check payment status
                    </v-btn>
                    <v-btn class="text-white" @click="openPayDialog" color="blue mr-2"
                           v-if="trekkingData.voucher_generated && !trekkingData.paid">
                      Pay manually
                    </v-btn>
                    <v-btn @click="generateVoucher" class="text-white" color="blue mr-2" :loading="loading"
                           v-if="!trekkingData.voucher_generated && parseFloat(trekkingData.total_cost) > 0.00"
                    >Generate voucher
                    </v-btn>
                    <v-btn
                        @click="print('permit')"
                        class="text-white"
                        color="blue lighten-1 ml-2"
                        v-if="(trekkingData.paid || parseFloat(trekkingData.total_cost) === 0.00) && trekkingData.status ==='Approved'">
                      Print Permit
                    </v-btn>
                    <v-btn
                        @click="printSticker"
                        class="text-white"
                        color="blue lighten-1 ml-2"
                        v-if="(trekkingData.paid || parseFloat(trekkingData.total_cost) === 0.00) && trekkingData.status ==='Approved' && trekkingData.print_trekking_sticker &&  $oauth.checkIfHasPermission(['print-trekking-sticker'])">
                      Print Sticker
                    </v-btn>
                    <v-btn
                        @click="attachDocument"
                        class="white--text"
                        color="blue lighten-1 ml-2"
                        v-if="showAttachDocuments"
                    >
                      Attach Document(s)
                    </v-btn>
                    <v-btn
                        @click="rejectModal=true "
                        class="text-white ml-2"
                        color="red lighten-1"
                        v-if=" trekkingData.paid && !trekkingData.approve_rejected">
                      Reject
                    </v-btn>
                    <v-btn
                        @click="approveModal=true "
                        class="text-white ml-2"
                        color="primary"
                        v-if="(trekkingData.paid || parseFloat(trekkingData.total_cost) === 0.00) && !trekkingData.approve_rejected">
                      Approve
                    </v-btn>
                  </v-layout>
                </v-footer>
              </v-tab-item>
              <v-tab-item value="history">
                <v-card flat :loading="loading">
                  <v-expansion-panels
                      v-model="panel"
                      multiple
                      v-if="trekkingData.assigned_track && trekkingData.assigned_track.length"
                      class="mb-4"
                  >
                    <v-expansion-panel>
                      <v-expansion-panel-header class="subtitle-2">Forwarded Tracks
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <trekking-assignment-history
                            :history="trekkingData.assigned_track"
                            :id="trekkingData.id"/>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <visa-history :history="trekkingData.tracks"
                                :show_load_more="false" :trekking="true" :editable="true"/>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout class="show-on-print" v-if="trekkingData.status === 'Approved'">
      <print-permit :schedule="trekkingData.schedule" :total_cost="trekkingData.total_cost" class="show-on-print"
                    :trekkers="trekkingData.trekkers"
                    :trekking-route="trekkingData.trekkingRoute" :trekkingAgency="trekkingData.trekkingAgency"
                    :trekkingData="trekkingData" :user="user" style="display: none"/>
    </v-layout>
    <v-layout class="show-on-print"
              v-if="trekkingData.status === 'Approved' && trekkingData.print_trekking_sticker &&  $oauth.checkIfHasPermission(['print-trekking-sticker'])">
      <trekking-request-sticker-print :schedule="trekkingData.schedule" :total_cost="trekkingData.total_cost"
                                      :trekkers="trekkingData.trekkers"
                                      :trekking-route="trekkingData.trekkingRoute"
                                      :trekkingAgency="trekkingData.trekkingAgency"
                                      :trekkingData="trekkingData" :user="user"
                                      style="display: none"
      />
    </v-layout>
    <approve-modal-ui :director="director" :single="true"/>
    <attach-file-dialog
        :url="'trekking-requests/attach-file/'+trekkingData.id"
        @attached="costExempted"
        v-model="attachFileDialog"
        :file-already-attached="fileAlreadyAttached"
    />
    <reject-modal-ui/>
    <manual-payment-dialog v-model="manualDialog" @paid="pay"
                           :url="'trekking-requests/pay-manually/'+trekkingData.id"/>
    <cost-exemption-dialog
        v-model="exemptionDialog"
        :max-amount="trekkingData.total_cost"
        :url="'trekking-requests/exempt-cost/'+trekkingData.id"
        @exempted="costExempted"
        :type="'trekking'"
    />
    <trekking-forward-dialog v-model="showForwardToUserModal" :purpose="forwardPurpose"/>
    <trekking-tippani-verification-modal @purposeCompleted="proceedCompletedPurpose"/>
    <v-layout class="show-on-print" v-show="trekkingData.voucher_number && trekkingData.status === 'Applied'">
      <trekking-voucher-print class="show-on-print"
                              :trekkingData="trekkingData" style="display: none"/>
    </v-layout>
    <v-layout class="show-on-print">
      <single-trekking-request-tippani-print-content class="show-on-print" style="display: none"/>
    </v-layout>
  </v-container>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import TrekkingRequestApproveModal from "../../../components/trekkingRequest/TrekkingRequestApproveModal";
import TrekkingRequestRejectModal from "../../../components/trekkingRequest/TrekkingRequestRejectModal";
import Print from '../single-trekking-request/TrekkingRequestPrint';
import ListItemDetail from "../../../components/ListItemDetail";
import PaymentDetail from "../../../components/PaymentDetail";
import HeaderText from "../../../components/HeaderText";
import ConfirmationHeaderText from "../../../components/ConfirmationHeaderText"
import FileDisplay from "../../../components/FileDisplay";
import FileListItemDetail from "../../../components/FileListItemDetail";
import TrekkingVoucherPrint from "../../../components/trekkingRequest/TrekkingVoucherPrint";
import ManualPaymentDialog from "../../../components/dialogs/ManualPaymentDialog";
import CostExemptionDialog from "../../../components/dialogs/CostExemptionDialog";
import VisaHistory from "../../visa/visa-request/VisaHistory";
import AttachFileDialog from "../../../components/dialogs/AttachFileDialog";
import TrekkingForwardDialog from "@/components/trekkingRequest/TrekkingForwardDialog.vue";
import TrekkingAssignmentHistory from "@/views/trekking/TrekkingAssignmentHistory.vue";
import TrekkingTippaniVerificationModal from "@/components/trekkingRequest/TrekkingTippaniVerificationModal.vue";

import {GET_TIPPANI_WITH_TYPE} from "../../../store/action-type";
import {
  SET_SELECTED_TIPPANI,
  SET_GENERATED_TIPPANI,
  SET_PRINT_CONTENT,
  SET_PRINT_CONTENT_ONLY
} from "../../../store/mutation-type";
import SingleTrekkingRequestTippaniPrintContent
  from "../../../components/trekkingRequest/SingleTrekkingRequestTippaniPrintContent"
import Quill from 'quill';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import TrekkingRequestStickerPrint from "../TrekkingRequestStickerPrint";

export default {
  components: {
    TrekkingTippaniVerificationModal,
    TrekkingAssignmentHistory,
    FileDisplay,
    Print,
    "approve-modal-ui": TrekkingRequestApproveModal,
    "reject-modal-ui": TrekkingRequestRejectModal, FileListItemDetail,
    'print-permit': Print,
    ListItemDetail,
    HeaderText,
    ConfirmationHeaderText, PaymentDetail, TrekkingVoucherPrint,
    ManualPaymentDialog,
    CostExemptionDialog,
    SingleTrekkingRequestTippaniPrintContent,
    VisaHistory,
    AttachFileDialog,
    TrekkingRequestStickerPrint,
    TrekkingForwardDialog
  },

  data() {
    return {
      title: 'Single-Trekking',
      tab: null,
      panel: [1, 0],
      valid: true,
      errors: [],
      mainLoading: false,
      director: false,
      printTippani: false,
      manualDialog: false,
      attachFileDialog: false,
      headers: [
        {
          text: 'number',
          value: 'document_number'
        }, {
          text: 'type',
          value: 'document_type'
        },
        {
          text: 'validity',
          value: 'validity'
        }
      ],
      showTippaniBeforePrint: false,
      showVoucher: false,
      exemptionDialog: false,
      tippaniDialog: false,
      step: 1,
      quill: null,
      hide: false,
      showForwardToUserModal: false,
      forwardPurpose: null
    };
  },
  computed: {
    ...mapGetters("TrekkingSingle", ["trekkingData", "loading"]),
    approveModal: {
      get() {
        return this.$store.state.TrekkingSingle.approveModal;
      },
      set(value) {
        this.$store.commit("TrekkingSingle/setApproveModal", value);
      }
    },
    rejectModal: {
      get() {
        return this.$store.state.TrekkingSingle.rejectModal;
      },
      set(value) {
        this.$store.commit("TrekkingSingle/setRejectModal", value);
      }
    },
    user() {
      return this.$store.state.AuthUser.user;
    },
    tippanis() {
      return this.$store.state.Tippani.tippanis;
    },
    selectedTippani: {
      get() {
        return this.$store.state.Tippani.selectedTippani;
      },
      set(value) {
        this.$store.commit(SET_SELECTED_TIPPANI, value)
      }
    },
    latest_status() {
      if (this.trekkingData && this.trekkingData.tracks) {
        const latest_status = this.trekkingData.tracks[0];
        let deleted_tracks = this.trekkingData.tracks.filter((i) => i.deletable && (i.deleted_at > latest_status.created_at));

        if (deleted_tracks.length > 0) {
          deleted_tracks.sort((a, b) => Date.parse(b.deleted_at) - Date.parse(a.deleted_at));
          return deleted_tracks[0].status + " Removed";
        }
        return latest_status.status;
      } else {
        return;
      }
    },
    statusColor() {
      if (this.latest_status) {
        if (this.latest_status.toLowerCase().includes('approved')) {
          return 'success';
        } else if (this.latest_status === 'Applied for trekking permit' || this.latest_status === 'Trekking rejected') {
          return 'red';
        }
        {
          return 'primary'
        }
      } else {
        return 'red';
      }
    },
    showAttachDocuments() {
      const {approve_rejected, paid, can_attach_file, payment_detail} = this.trekkingData;

      // if (parseInt(payment_detail.amount) === 0) {
      //   return !approve_rejected && can_attach_file;
      // }
      // return !approve_rejected && can_attach_file;
      return can_attach_file;

    },
    fileAlreadyAttached() {
      const {file_attached} = this.trekkingData;
      return file_attached;
    },

    showForward() {
      const {automation_enabled, status, assignment, isTippaniVerified} = this.trekkingData;
      if (automation_enabled) {
        return (
            isTippaniVerified &&
            (status !== 'Approved') &&
            (!assignment || assignment.assignee_id === this.user.id) &&
            this.$oauth.checkIfHasPermission(['forward-trekking-request'])
        )
      }
      return false;
    },

    showTippaniVerification() {
      const {automation_enabled, status, assignment, isTippaniVerified, tippani_generated} = this.trekkingData;
      // console.log(this.user, assignment && assignment.assignee_id === this.user.id && assignment.purpose === 0)
      // console.log('this', this.user,  assignment && assignment.assignee_id === this.user.id && assignment.purpose === 0)
      if (automation_enabled) {
        return (
            tippani_generated &&
            !isTippaniVerified &&
            (status !== 'Approved') &&
            (assignment && assignment.assignee_id === this.user.id && assignment.purpose === 0)
        );
      }
      return false;
    },

    showTippaniApprove() {
      const {automation_enabled, status, assignment, isTippaniVerified, tippani_generated} = this.trekkingData;
      if (automation_enabled) {
        return (
            tippani_generated &&
            isTippaniVerified &&
            (status !== 'Approved') &&
            (assignment && assignment.assignee_id === this.user.id && assignment.purpose === 2)
        );
      }
      return false;
    },
  },
  methods: {
    ...mapActions("TrekkingSingle", [
      "resetState",
      "getTrekkingRequestDetail",
      "getSingleTrekkingRequestDetail",
      "generateTippaniPdf",
      "checkPaymentStatus",
      "generateVoucherNumber",
      "verifySingleTrekkingRequest",
      "saveSingleTippani",
      "generateTrekkingStickerPrintedTrack"
    ]),
    print(type) {
      if (type === 'tippani') {
        const content = document.getElementById('single_tippani_content').innerHTML;
        this.$store.commit(SET_PRINT_CONTENT, content)
      }
      if (type === 'initial_tippani') {
        const content = document.getElementById('single_tippani_content').innerHTML;
        this.$store.commit(SET_PRINT_CONTENT_ONLY, content);
        setTimeout(() => {
          window.print()
        }, 100);
      }


      if (type === 'voucher') {

        const content = document.getElementById('voucher_print_content').innerHTML;
        this.$store.commit(SET_PRINT_CONTENT, content)
      }
      if (type === 'permit') {

        const content = document.getElementById('permit_content').innerHTML;
        this.$store.commit(SET_PRINT_CONTENT, content)
      }

      if (type === 'sticker') {
        const content = document.getElementById('sticker_content').innerHTML;
        this.$store.commit(SET_PRINT_CONTENT_ONLY, content)
        this.generateTrekkingStickerPrintedTrack()
            .then(() => {
              setTimeout(() => {
                window.print()
              }, 100);
              this.$store.commit("Notification/showSuccess", "Trekking sticker printed track generated successfully");
            })
            .catch(error => {
              this.$store.commit('Notification/showError', error.response.data.message)
            });
      }
    },
    printSticker() {
      var self = this;
      if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open) {
        // console.log(this.visa_request.prn_file_content)
        this.generateTrekkingStickerPrintedTrack()
            .then(() => {
              //Create a ClientPrintJob
              var cpj = new JSPM.ClientPrintJob();
              //Set Printer type (Refer to the help, there many of them!)
              cpj.clientPrinter = 0;
              cpj.printerCommandsCodePage = -1;
              //Set printer commands...
              self.trekkingData.trekkers.forEach(item => {
                cpj.printerCommands = item.permit_prn_content;
                cpj.sendToClient();
              });
              this.$store.commit("Notification/showSuccess", "Trekking sticker printed track generated successfully");
            })
            .catch(error => {
              this.$store.commit('Notification/showError', error.response.data.message)
            });
      } else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
        this.$store.commit('Notification/showError', "JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm")
        return false;
      } else if (
          JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked
      ) {
        this.$store.commit('Notification/showError', "JSPM has blocked this website!")
        return false;
      }
    },
    jspmWSStatus() {
      if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open)
        return true;
      else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
        // alert(
        //     "JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm"
        // );
        return false;
      } else if (
          JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked
      ) {
        // alert("JSPM has blocked this website!");
        return false;
      }
    },
    pay() {
      let id = this.$route.params.id;
      this.getTrekkingRequestDetail(id).finally(() => {
        this.mainLoading = false;
      });
    },
    openPayDialog() {
      this.manualDialog = true;
    },
    generateVoucher() {
      this.loading = true;
      this.generateVoucherNumber().then(() => {
        this.loading = false;
        this.$store.commit('Notification/showSuccess', 'Voucher has been generated')
      }).catch((err) => {
        this.loading = false;
        this.$store.commit('Notification/showError', err.response.data.message)
      })
    },
    checkPayment() {
      this.loading = true;
      this.checkPaymentStatus().then(() => {
        this.loading = false;
        this.$store.commit('Notification/showSuccess', 'Amount has been paid')
      }).catch((err) => {
        this.loading = false;
        this.$store.commit('Notification/showError', 'Not paid')
      });
    },
    costExempted() {
      let id = this.$route.params.id;
      this.getSingleTrekkingRequestDetail(id)
    },
    verifyTrekking() {
      this.loading = true;
      this.verifySingleTrekkingRequest().then(() => {
        this.loading = false;
        this.$store.commit('Notification/showSuccess', 'The Trekking Request has been verified');
        this.costExempted();
      }).catch(() => {
        this.loading = false;
        this.$store.commit('Notification/showError', 'Something went wrong')
      })
    },
    async generateTippani() {
      this.step = 1;
      await this.$store.dispatch(GET_TIPPANI_WITH_TYPE, this.title);
      this.tippaniDialog = true;
      setTimeout(() => {
        if (!this.quill)
          this.quill = new Quill('#editor', {
            theme: 'snow',
            modules: {
              toolbar: [
                [{header: [1, 2, false]}],
                ['bold', 'italic', 'underline'],
              ],
            },
          });
      }, 200);

    },
    async forwardToUser(type) {
      this.forwardPurpose = type ? type : 0;
      this.showForwardToUserModal = true;
    },

    fillTippani() {
      let tippani = this.tippanis.find(i => i.id === this.selectedTippani);
      tippani = tippani.text;
      tippani = tippani.replace('@total_trekkers', this.trekkingData.trekkers.length);
      tippani = tippani.replace('@trekking_route_name', this.trekkingData.trekkingRoute.name);
      tippani = tippani.replace('@trekking_agency_name', this.trekkingData.trekkingAgency.name);
      tippani = tippani.replace('@starting_date', this.trekkingData.starting_date);
      tippani = tippani.replace('@trekking_route_name', this.trekkingData.trekkingRoute.name);
      tippani = tippani.replace('@trekking_days', this.trekkingData.no_of_days);
      this.$store.commit(SET_GENERATED_TIPPANI, tippani);
      this.quill.root.innerHTML = tippani;
    },
    cancel() {
      if (this.step === 1) {
        this.tippaniDialog = false;

      } else {
        this.hide = false;
        this.step = 1;
      }
    },
    proceed() {
      const tippani = this.quill.root.innerHTML;
      this.$store.commit(SET_GENERATED_TIPPANI, tippani);
      this.hide = true;
      this.step = 2;
    },
    async save() {
      try {
        try {
          const r = await this.saveSingleTippani({
            content: this.quill.root.innerHTML
          })
          this.tippaniDialog = false;
          this.$store.commit('Notification/showSuccess', 'Tippani generated successfully')
          if (this.trekkingData.automation_enabled) {
            this.showForwardToUserModal = true;
          }
        } catch (e) {
          this.tippaniDialog = false;

        }
      } catch (e) {
        throw e;
      }
    },
    attachDocument() {
      this.attachFileDialog = true;
    },

    verifyTippaniGenerated() {
      this.$store.commit("TrekkingSingle/setTippaniVerificationModal", true);
      this.$store.commit("TrekkingSingle/setForwardPurpose", 'verify-tippani');
    },
    approveTippaniGenerated() {
      this.$store.commit("TrekkingSingle/setTippaniVerificationModal", true);
      this.$store.commit("TrekkingSingle/setForwardPurpose", 'approve-tippani');
    },
    proceedCompletedPurpose(data = null) {
      this.getTrekkingRequestDetail(this.trekkingData.id);
      if (this.trekkingData.automation_enabled) {
        if (data && data === 'verify-tippani') {
          this.forwardToUser(2)
        }
      }
    },

  },
  watch: {
    "$route.params.id": function () {
      if(this.route.name === 'ViewSingleTrekkingRequest'){
        this.mainLoading = true;
        let id = this.$route.params.id;
        this.getSingleTrekkingRequestDetail(id).finally(() => {
          this.mainLoading = false;
        });
      }
    }
  },
  mounted() {
    this.mainLoading = true;
    let id = this.$route.params.id;
    this.getSingleTrekkingRequestDetail(id).finally(() => {
      this.mainLoading = false;
    });


    JSPM.JSPrintManager.auto_reconnect = true;
    JSPM.JSPrintManager.start();
    const self = this;
    JSPM.JSPrintManager.WS.onStatusChanged = function () {
      if (self.jspmWSStatus()) {
        //get client installed printers
        JSPM.JSPrintManager.getPrinters().then(function (myPrinters) {
          // var options = "";
          // for (var i = 0; i < myPrinters.length; i++) {
          //   options += "<option>" + myPrinters[i] + "</option>";
          // }
          console.log(myPrinters);
          // $("#installedPrinterName").html(options);
          self.printers = myPrinters;
        });
      }
    };
  }
};
</script>

<style>
.hide {
  display: none;
}
</style>
